import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBubbleAlert: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconBubbleAlert"><Path fillRule="evenodd" clipRule="evenodd" d="M21 3H3V19H8.74274L11.9951 21.7263L15.2858 19H21V3ZM12.75 7V12.5H11.25V7H12.75ZM12.75 13.5H11.25V15H12.75V13.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBubbleAlert;
